/**
 * Configuración global de mutations
 */
export const ON_ROUTE = "ON_ROUTE";
export const ON_IS_LOADING = "ON_IS_LOADING";
export const ON_PASO_1 = "ON_PASO_1";
export const ON_PASO_2 = "ON_PASO_2";
export const ON_PASO_3 = "ON_PASO_3";
export const ON_GRACIAS = "ON_GRACIAS";
export const ON_NOTIFICATION_TOAST = "ON_NOTIFICATION_TOAST";
export const ON_NOTIFICATION_MODAL = "ON_NOTIFICATION_MODAL";
export const ON_FORZAR_DNE = "ON_FORZAR_DNE";
export const ON_CODIGO_POSTAL = "ON_CODIGO_POSTAL";
export const ON_ERROR = "ON_ERROR";
export const ON_ERROR_MERLIN = "ON_ERROR_MERLIN";
export const ON_CONSULTA_DATOS_PATENTE = "ON_CONSULTA_DATOS_PATENTE";
export const ON_LIMPIAR_DATOS_PATENTE = "ON_LIMPIAR_DATOS_PATENTE";
export const ON_CONSULTA_MARCAS_AUTO = "ON_CONSULTA_MARCAS_AUTO";
export const ON_CONSULTA_MODELOS_AUTO = "ON_CONSULTA_MODELOS_AUTO";
export const ON_CONSULTA_VERSION_AUTO = "ON_CONSULTA_VERSION_AUTO";
export const ON_CONDICION = "ON_CONDICION";
export const ON_CONSULTA_SIMULACION_COTIZACION =
  "ON_CONSULTA_SIMULACION_COTIZACION";
export const ADOBE_INTERNAL_LINK = "ADOBE_INTERNAL_LINK";
export const ADOBE_APP_STARTED = "ADOBE_APP_STARTED";
export const ADOBE_APP_ON_CLICK_START = "ADOBE_APP_ON_CLICK_START";
export const ADOBE_MODAL = "ADOBE_MODAL";
export const ON_CONSULTA_VIVIENDA = "ON_CONSULTA_VIVIENDA";
export const ON_COTIZACION_HOGAR = "ON_COTIZACION_HOGAR";
export const ON_RECOTIZACION_HOGAR = "ON_RECOTIZACION_HOGAR";
export const ON_GUARDAR_DESCRIPCION_VIVIENDA =
  "ON_GUARDAR_DESCRIPCION_VIVIENDA";

export const ON_COBERTURA_ANADIR = "ON_COBERTURA_ANADIR";
export const ON_COBERTURA_QUITAR = "ON_COBERTURA_QUITAR";
export const ON_COBERTURA_QUITAR_TODAS = "ON_COBERTURA_QUITAR_TODAS";
export const ON_COBERTURAS_SELECCIONADAS = "ON_COBERTURAS_SELECCIONADAS";

export const ON_LIMPIAR_DATOS_PASO1HOGAR = "ON_LIMPIAR_DATOS_PASO1HOGAR";
export const ON_OBTENER_PDF_HOGAR = "ON_OBTENER_PDF_HOGAR";

export const ON_NORMALIZAR_CELULAR = "ON_NORMALIZAR_CELULAR";
export const ADOBE_QUIERO_QUE_ME_CONTACTEN = "ADOBE_QUIERO_QUE_ME_CONTACTEN";
export const ON_USER_ID_TOKENIZADO = "ON_USER_ID_TOKENIZADO";
